import { type PropsWithChildren, forwardRef } from "react";
import { type LinkProps, Link as _Link, useLocation } from "react-router";

import { preserveCaseReturnTo } from "@/modules/case/utils/return-to";

export const Link = forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<Omit<LinkProps, "to"> & { href: string }>
>(function Link(props, ref) {
  const location = useLocation();

  return (
    <_Link
      {...props}
      to={preserveCaseReturnTo(props.href, location)}
      ref={ref}
    />
  );
});
